import styled from "styled-components";
export const Container = styled.div`
  overflow-y: auto;
  margin-top: 20px;
  padding-bottom: 20px;
  width: 100%;
`;
export const Wrapper = styled.div`
  width: 70%;
  height: auto;
  padding: 20px;
  box-sizing: border-box;
  margin: 30px auto 0px auto;
  overflow: auto;
  display: flex; 
  flex-direction: column;
  border: 1px solid #c9c9c9;
  border-radius: 14px;
  max-width: 550px;
  background-image: url("/fundo_branco.png");
  background-size: cover;
  
  @media (max-width: 550px) {
    border-radius: 0px;}
  @media (max-width: 767px) {
    width: 100%;
    margin: 20px auto;
  }
  @media (max-width: 425px) {
    /* width: 20rem; */
    margin: 20px auto;
  }
  @media (max-width: 375px) {
    /* width: 18rem; */
  }
`;
export const Title = styled.h1`
  width: 100%;
  text-align: center;
  margin-bottom: 20px;
  font-size: 26px;
  color: #2c2c2c;
`;
export const SubTitle = styled.p`
  width: 100%;
  text-align: center;
  margin-bottom: 10px;
  color: #2c2c2c;
`;
export const MessageTime = styled.p`
  width: 100%;
  padding: 2px 4px;
  margin-top: 10px;
  margin-bottom: 20px;
  color: #2c2c2c;
 `;
export const MessageEmail = styled.p`
  width: 100%;
  text-align: left;
  text-decoration: underline;
  color: #2c2c2c;
 `;
export const FormWrapper = styled.div`
  height: auto;
`;
export const ContainerInfos = styled.div`
  color: #2c2c2c;
  margin-bottom: 10px;
  @media (max-width: 767px) {
    padding: 0 5px;
    font-size: 14px;
  }
`;
export const ContainerInputs = styled.div`
  gap: 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  @media (max-width: 1000px) {
    flex-direction: column;
  }
`;
export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 20px;
  gap: 0.5rem;
  input {
    color: #2c2c2c;
    font-family: "Archivo-Regular";
    border: 1px solid #ccc;
    border-radius: 99px;
    height: 40px;
    padding-left: 10px;
    &:focus {
      outline: none;
      border: 1px solid #000;
    }    
  }
`;
export const InputWrapperCode = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-bottom: 20px;
  gap: 0.5rem;
  input {
    color: #2c2c2c;
    font-family: "Archivo-Regular";
    border: 1px solid #ccc;
    border-radius: 99px;
    font-size: 16px;
    letter-spacing: 0.7rem;
    font-family: "Archivo-SemiBold";

    width: 170px;
    height: 40px;
    text-align: center;
    &:focus {
      outline: none;
      border: 1px solid #000;
    }
    &::placeholder {
      letter-spacing: 0.1rem;
    }  
  }
  
`;
export const Label = styled.label`
  color: #2c2c2c;
  font-size: 16px;
  font-weight: 700;
  white-space: nowrap;
`;

export const Form = styled.form`
  width: 100%;
`;

interface ButtonProps {
  backgroundColor: string;
  hoverBackgroundColor: string;
  cursor?: string;
}
interface WrapperButtonProps {
  isSecond: boolean;
}
export const WrapperButton = styled.div<WrapperButtonProps>`
  display: flex;
  justify-content: ${(props) => (props.isSecond ? "space-between" : "center")};
  gap: 40px;
  @media (max-width: 426px) {
    gap: 10px;
    padding: 0 5px;
  }
`;
export const Button = styled.button<ButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  background-color: ${(props) => props.backgroundColor};
  cursor: ${(props) => props.cursor || "pointer"};
  border: none;
  border-radius: 99px;
  width: 96px;
  height: 40px;
  padding: 10px;
  font-family: "Archivo-Regular";
  text-transform: uppercase;
  color: #2c2c2c;
  &:hover {
    transition: all 0.2s;
    background-color: ${(props) => props.hoverBackgroundColor};
  }
`;
export const ButtonBack = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  border: none;
  background-color: #355B94;
  border-radius: 99px;
  cursor: pointer;
  color: #fff;
  width: 96px;
  height: 40px;
  text-transform: uppercase;
  font-family: "Archivo-Regular";
  &:hover {
    transition: all 0.2s;
    background: #32568c;
  }
`;
